var map = {
	"./icon-attendance.png": 39450,
	"./icon-bed.png": 53094,
	"./icon-classname.png": 97642,
	"./icon-clearplate.png": 35930,
	"./icon-dorm.png": 88015,
	"./icon-educational.png": 95554,
	"./icon-elective.png": 61502,
	"./icon-face.png": 57712,
	"./icon-facedoor.png": 68452,
	"./icon-familycall.png": 36187,
	"./icon-headmaster.png": 8363,
	"./icon-health.png": 33865,
	"./icon-leave.png": 73086,
	"./icon-meal.png": 13098,
	"./icon-message.png": 64742,
	"./icon-moral.png": 60890,
	"./icon-recipes.png": 59542,
	"./icon-vehicle.png": 30203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9754;